var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36.25H26.25",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.297 26.0934C10.8089 24.9362 9.6036 23.4556 8.77251 21.7637C7.94142 20.0717 7.50631 18.2128 7.50013 16.3277C7.46888 9.54648 12.922 3.90586 19.7033 3.74961C22.3277 3.68739 24.9052 4.45305 27.0701 5.93799C29.2349 7.42293 30.8774 9.55177 31.7644 12.0226C32.6514 14.4934 32.7379 17.1808 32.0118 19.7036C31.2857 22.2264 29.7837 24.4565 27.7189 26.0777C27.2628 26.4303 26.8933 26.8825 26.6387 27.3997C26.3842 27.917 26.2512 28.4856 26.2501 29.0621V29.9996C26.2501 30.3311 26.1184 30.6491 25.884 30.8835C25.6496 31.1179 25.3317 31.2496 25.0001 31.2496H15.0001C14.6686 31.2496 14.3507 31.1179 14.1163 30.8835C13.8818 30.6491 13.7501 30.3311 13.7501 29.9996V29.0621C13.7462 28.4899 13.6136 27.926 13.362 27.4121C13.1105 26.8981 12.7465 26.4474 12.297 26.0934Z",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2656 8.875C22.7934 9.13398 24.2031 9.86079 25.3002 10.9551C26.3973 12.0494 27.1277 13.4573 27.3906 14.9844",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS43);
export default __webpack_public_path__ + "static/media/s4-3.a8e227c54cebb244dfd66eb71238518f.svg";
export { ForwardRef as ReactComponent };